export default __webpack_public_path__ + "securityGreen.ce1a2ed1.png";